import $ from 'jquery';

function updateFormAttrAction(event) {
	const isKeydown = event.type === 'keydown';
	const isEnter = event.key === 'Enter' || event.keyCode === 13;
	const isSubmit = (isKeydown && isEnter) || event.type === 'submit';

	if (isSubmit)
		event.preventDefault();

	if (!isKeydown || isSubmit) {
		const { delegateTarget: form } = event;
		const { action: url } = form;

		const filterData = new FormData(event.delegateTarget);
		filterData.append('ajax', 'y');

		const searchData = new URLSearchParams(filterData);
		const queryString = searchData.toString();

		const ajaxGet = $.get({
			url,
			data: queryString,
			dataType: 'json',
			converters: {
				'text json': JSON.parse
			}
		});

		ajaxGet.done((data) => {
			form.setAttribute('action', data['FILTER_URL']);

			if (isSubmit)
				form.submit();
		});
	}
}

$('form.smartfilter').on('change submit keydown', updateFormAttrAction);
